import { Controller } from "@hotwired/stimulus";

/**
 * Iframe Height Controller
 * Makes a same-origin iframe as tall as its document (the admin newsletter preview), so a short
 * email leaves no empty space and a long one needs no inner scrollbar.
 *
 * Usage:
 *   iframe src=same_origin_path data-controller="iframe-height" data-action="load->iframe-height#fit"
 */
export default class extends Controller<HTMLIFrameElement> {
  fit(): void {
    const doc = this.element.contentDocument;
    if (!doc) return;

    this.element.style.height = `${doc.documentElement.scrollHeight}px`;
  }
}
